import { agendaCaseAdapter } from './reducer'
import { EntityState } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'
import { IMeetingAgendaModel } from '../../../models/BoardMeeting'

export interface ICaseError {
  id: string
  message: string
}

export interface ICaseReferances {
  [x: string]: HTMLDivElement
}

export interface IBaseState {
  loading: boolean
  error: string | null
  casesError: ICaseError[]
  focusedCaseId: string | null
}

interface IState extends EntityState<IMeetingAgendaModel>, IBaseState {}

export const getMeetingAgendaCaseById =
  (caseId: string) => (state: RootState) =>
    agendaCaseAdapter
      .getSelectors((x: RootState) => x.boardmeetings.manage.agenda)
      .selectById(state, caseId)

export const getAllAgendaCases = (state: RootState) =>
  agendaCaseAdapter
    .getSelectors((x: RootState) => x.boardmeetings.manage.agenda)
    .selectAll(state)

export const getCaseError = (caseId: string) => (state: RootState) =>
  (state.boardmeetings.manage.agenda as IState).casesError.find(
    ({ id }) => id === caseId
  )

export const getCaseReferance = (state: RootState) =>
  (state.boardmeetings.manage.agenda as IState).focusedCaseId
